import { FC, ReactElement } from 'react'
import { useToggle } from 'react-use'

import { FilterSection } from '../../../components'
import { IconButton, ModalContent, PacoModal } from '../../../compositions'
import {
    ConnectedAddShiftForm,
    ConnectedDepartmentsFilter,
    ConnectedEmployeesFilter,
    ConnectedResetFiltersButton,
} from '../../../connectors'
import useCheckPermission from '../../../helpers/hooks/useCheckPermission'
import trans from '../../../helpers/trans'

import './ShiftsCalendarFilterContainer.scss'

interface ShiftsCalendarFilterContainerProps {
    className?: string;
}

const ShiftsCalendarFilterContainer: FC<ShiftsCalendarFilterContainerProps> = ({ className = '' }): ReactElement => {
    const [addShiftModalIsOpen, toggleAddShiftModalIsOpen] = useToggle(false)
    const canAddNewShifts = useCheckPermission('add-new-shifts')

    return (
        <>
            <form className={`shifts-calendar-filter-container ${className}`}>
                {canAddNewShifts && (
                    <FilterSection>
                        <IconButton
                            icon="plus"
                            text={trans('common.addShift')}
                            onClick={toggleAddShiftModalIsOpen}
                            className="shifts-calendar-filter-container__add-shift-button"
                        />
                    </FilterSection>
                )}

                <FilterSection>
                    <ConnectedResetFiltersButton className="shifts-calendar-filter-container__reset-filters-button" />
                </FilterSection>

                <FilterSection>
                    <ConnectedEmployeesFilter />
                </FilterSection>

                <FilterSection>
                    <ConnectedDepartmentsFilter />
                </FilterSection>
            </form>

            {addShiftModalIsOpen && (
                <PacoModal onClose={() => toggleAddShiftModalIsOpen(false)}>
                    <ModalContent title={trans('common.addShift')}>
                        <ConnectedAddShiftForm onClose={toggleAddShiftModalIsOpen} />
                    </ModalContent>
                </PacoModal>
            )}
        </>
    )
}

export default ShiftsCalendarFilterContainer
